import { ProviderPopupClosedError } from '../../errors/provider-popup-closed-error';

export class GoogleProviderPopupClosedError extends ProviderPopupClosedError {
	constructor() {
		super();
		this.name = 'GoogleProviderPopupClosedError';
	}
}
